const LogoIconSm = () => {
  return (
    <svg
      width="32"
      height="48"
      viewBox="0 0 32 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5377 6.54545C16.1619 3.92727 15.568 1.09091 15.568 0C12 4.18977 13.4648 9.39773 17.5556 13.4261C21.5572 17.3668 21.1363 20.3636 20.3938 21.4545C20.8888 21.0909 22.8174 20.0488 23.7348 17.4545C25.1852 13.3534 21.5075 9.81818 18.5377 6.54545Z"
        fill="url(#paint0_linear_4688_9383)"
      />
      <path
        d="M15.1961 14.1818C13.4138 12.1455 11.9787 8.9697 11.4839 7.63636C11.3606 7.63636 10.2568 8.40795 9.6292 10.5455C8.74074 13.5716 10.8148 16.2625 11.8565 17.8182C12.2758 18.4443 12.542 19.1453 11.8565 19.2727C10.4444 19.5352 8.14815 15.4625 8.14815 15.4625C7.85117 18.0807 8.88536 20 8.88536 20C8.88536 20 10.3704 23.5352 15.1961 23.2727C19.0753 22.8244 19.0325 20.3636 18.5377 19.2727C18.1665 18.4242 18.0606 17.4545 15.1961 14.1818Z"
        fill="url(#paint1_linear_4688_9383)"
      />
      <path
        d="M6.66667 17.4989V14.5898L0 16.7716V32.7716C0 37.208 3.55556 41.5716 15.94 48C28.4444 41.5716 32 37.208 32 32.7716V16.7716L25.3333 14.5898V17.4989C26.447 17.8625 28.4444 18.517 29.7778 18.9534V31.8989C29.7778 34.517 28.5185 38.8807 17.7778 44.2625L20 28.117L24 26.2261V24.7716H16.2963V45.0625L15.9259 45.2807L15.5556 45.0625V24.7716H7.85185V26.2261L11.8519 28.117C12.4706 32.2383 14.0741 44.2625 14.0741 44.2625C3.48148 38.8807 2.22222 34.517 2.22222 31.8989V18.9534L6.66667 17.4989Z"
        fill="url(#paint2_linear_4688_9383)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4688_9383"
          x1="16"
          y1="8.15012e-06"
          x2="-6.53451"
          y2="32.2581"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2A7CCC" />
          <stop offset="1" stop-color="#1261A9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4688_9383"
          x1="16"
          y1="8.15012e-06"
          x2="-6.53451"
          y2="32.2581"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2A7CCC" />
          <stop offset="1" stop-color="#1261A9" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4688_9383"
          x1="16"
          y1="8.15012e-06"
          x2="-6.53451"
          y2="32.2581"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2A7CCC" />
          <stop offset="1" stop-color="#1261A9" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LogoIconSm;
